<template>
    <register />
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Register from './Register';

export default {
    name: 'register-container',
    components: {
        Register,
    },
    created() {
    },
    methods: {
        ...mapActions('orgTypes', ['fetchOrgTypes']),
        ...mapActions('regions', ['fetchRegions']),
    },
    computed: {
        ...mapState('orgTypes', ['orgTypes']),
        ...mapState('regions', ['regions']),
    }
}
</script>



// WEBPACK FOOTER //
// RegisterContainer.vue?6bf80e43